// :cow: Cosmose CONFIDENTIAL :iso:
import { Action, createReducer, on } from '@ngrx/store';
import { stepIdUpdated, stepsUpdated, stepUpdated } from '@med/app/home/demo/guided-tour/store/guided-tour.actions';
import { Step } from '@med/app/home/demo/guided-tour/models/step';


export const STATE_NAME = 'guided-tour';

export interface State {
  stepId: string;
  steps: Step[];
  step: Step;
}

const initialState: State = {
  stepId: undefined,
  steps: undefined,
  step: undefined,
};

const reducer = createReducer(
  initialState,
  on(stepIdUpdated, (state, action) => ({...state, stepId: action.stepId})),
  on(stepsUpdated, (state, action) => ({...state, steps: action.steps})),
  on(stepUpdated, (state, action) => ({...state, step: action.step})),
);

export function guidedTourReducer(state: State | undefined, action: Action) {
  return reducer(state, action);
}

